import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { ChatProvider } from './context/ChatContext';
import { LogsModalProvider } from './context/LogsModalContext';
import { AppConfigModalProvider } from './context/AppConfigModalContext';
import ChatWidget from './components/chat/ChatWidget';
import LogsModal from './components/logs/LogsModal';
import AppConfigModal from './components/appconfig/AppConfigModal';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Earnings from './pages/Earnings';
import Users from './pages/Users';
import Drivers from './pages/Drivers';
import Rides from './pages/Rides';
import Payments from './pages/Payments';
import WalletRecharges from './pages/WalletRecharges';
import Collections from './pages/Collections';
import PromoCodes from './pages/PromoCodes';
import VehicleTypes from './pages/VehicleTypes';
import FareConfig from './pages/FareConfig';
import Plans from './pages/Plans';
import Support from './pages/Support';
import Offers from './pages/Offers';
import Banners from './pages/Banners';
import SafetyAlerts from './pages/SafetyAlerts';
import DocumentTypes from './pages/DocumentTypes';
import Notifications from './pages/Notifications';
import Settings from './pages/Settings';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('vandigo_access_token');
  if (!token) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <ToastProvider>
            <LogsModalProvider>
              <AppConfigModalProvider>
                <ChatProvider>
                  <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                    <Route path="/earnings" element={<PrivateRoute><Earnings /></PrivateRoute>} />
                    <Route path="/users" element={<PrivateRoute><Users /></PrivateRoute>} />
                    <Route path="/drivers" element={<PrivateRoute><Drivers /></PrivateRoute>} />
                    <Route path="/rides" element={<PrivateRoute><Rides /></PrivateRoute>} />
                    <Route path="/payments" element={<PrivateRoute><Payments /></PrivateRoute>} />
                    <Route path="/wallet-recharges" element={<PrivateRoute><WalletRecharges /></PrivateRoute>} />
                    <Route path="/collections" element={<PrivateRoute><Collections /></PrivateRoute>} />
                    <Route path="/promo-codes" element={<PrivateRoute><PromoCodes /></PrivateRoute>} />
                    <Route path="/vehicle-types" element={<PrivateRoute><VehicleTypes /></PrivateRoute>} />
                    <Route path="/fare-config" element={<PrivateRoute><FareConfig /></PrivateRoute>} />
                    <Route path="/plans" element={<PrivateRoute><Plans /></PrivateRoute>} />
                    <Route path="/support" element={<PrivateRoute><Support /></PrivateRoute>} />
                    <Route path="/offers" element={<PrivateRoute><Offers /></PrivateRoute>} />
                    <Route path="/banners" element={<PrivateRoute><Banners /></PrivateRoute>} />
                    <Route path="/safety-alerts" element={<PrivateRoute><SafetyAlerts /></PrivateRoute>} />
                    <Route path="/document-types" element={<PrivateRoute><DocumentTypes /></PrivateRoute>} />
                    <Route path="/notifications" element={<PrivateRoute><Notifications /></PrivateRoute>} />
                    <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                  </Routes>
                  <ChatWidget />
                  <LogsModal />
                  <AppConfigModal />
                </ChatProvider>
              </AppConfigModalProvider>
            </LogsModalProvider>
          </ToastProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
